document.addEventListener('DOMContentLoaded', function () {
	const scrollBlock = document.querySelector('.home-scroll-blocks');
	if (!scrollBlock) return;

	const heroes = scrollBlock.querySelectorAll('.home-hero');
	let stickyApplied = false;

	window.addEventListener('scroll', function () {
		const scrollTop = window.scrollY;

		if (scrollTop > 0 && !stickyApplied) {
			heroes.forEach((hero) => {
				hero.style.position = 'sticky';
				hero.style.bottom = '0';
				hero.style.width = '100%';
			});
			stickyApplied = true;
		} else if (scrollTop === 0 && stickyApplied) {
			heroes.forEach((hero) => {
				hero.style.position = '';
				hero.style.bottom = '';
				hero.style.width = '';
			});
			stickyApplied = false;
		}
	});

	// z-index control
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					heroes.forEach((hero, index) => {
						hero.style.zIndex = 10 - index - 3;
					});
				} else {
					heroes.forEach((hero, index) => {
						hero.style.zIndex = 10 - index;
					});
				}
			});
		},
		{ threshold: 0.1 }
	);

	observer.observe(scrollBlock);
});
